import React, { useState } from "react";
import Select from "react-select";
import { toast } from "react-toastify";

import {
    FiX,
    FiUserCheck,
} from "react-icons/fi";

const ReassignTaskModal = ({
    open,
    onClose,
    users,
    task,
    onSubmit,
}) => {

    console.log(users)
    const [translator, setTranslator] =
        useState(null);

    const [loading, setLoading] =
        useState(false);


    if (!open) return null;


    // =====================================================
    // SUBMIT
    // =====================================================
    const handleSubmit = async () => {
        if (!translator) {
            toast.error("Please select translator");
            return;
        }

        try {
            setLoading(true);
            await onSubmit(task.id, translator.value);
            toast.success("Task reassigned successfully");
            onClose();
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Failed to reassign task");
        } finally {
            setLoading(false);
        }
    };


    return (
        <div
            className="
                fixed
                inset-0
                bg-black/40
                z-50
                flex
                items-center
                justify-center
                p-4
            "
        >

            {/* MODAL */}
            <div
                className="
                    bg-white
                    rounded-3xl
                    shadow-2xl
                    w-full
                    max-w-lg
                    overflow-hidden
                "
            >

                {/* HEADER */}
                <div
                    className="
                        flex
                        justify-between
                        items-center
                        px-7
                        py-5
                        border-b
                    "
                >
                    <div>

                        <h2
                            className="
                                text-2xl
                                font-bold
                                text-gray-800
                            "
                        >
                            Reassign Task
                        </h2>

                        <p className="text-sm text-gray-500 mt-1">
                            Assign task to another
                            translator
                        </p>
                    </div>

                    <button
                        onClick={onClose}
                        className="
                            p-2
                            rounded-lg
                            hover:bg-gray-100
                        "
                    >
                        <FiX size={20} />
                    </button>
                </div>


                {/* BODY */}
                <div className="p-7">

                    {/* SELECT */}
                    <div className="">
                        <label
                            className="
                                text-sm
                                font-medium
                                text-gray-700
                                mb-2
                                block
                            "
                        >
                            Select Translator
                        </label>

                        <Select
                            options={[...users]
                                .filter((u) => u?.label)
                                .sort((a, b) =>
                                    a.label
                                        .toLowerCase()
                                        .localeCompare(
                                            b.label.toLowerCase()
                                        )
                                )
                            }
                            isClearable
                            value={translator}
                            onChange={setTranslator}
                            placeholder="Choose translator"
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            styles={{
                                menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                }),
                            }}
                        />
                    </div>
                </div>


                {/* FOOTER */}
                <div className="flex justify-end gap-3 px-7 py-5 border-t bg-gray-50">

                    {/* CANCEL */}
                    <button
                        onClick={onClose}
                        className="
                            px-5
                            py-3
                            rounded-xl
                            border
                            border-gray-200
                            hover:bg-gray-100
                            transition
                        "
                    >
                        Cancel
                    </button>


                    {/* SUBMIT */}
                    <button
                        onClick={handleSubmit}
                        disabled={loading}
                        className=" 
                            flex
                            items-center
                            gap-2
                            bg-indigo-600
                            hover:bg-indigo-700
                            disabled:opacity-50
                            text-white
                            px-6
                            py-3
                            rounded-xl
                            shadow-md
                            transition
                        "
                    >
                        <FiUserCheck />

                        {loading
                            ? "Reassigning..."
                            : "Reassign"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ReassignTaskModal;